require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-gruppo-di-ricerca-nicola-navone.json") })
        }
      }, "path---en-gruppo-di-ricerca-nicola-navone");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-gruppo-di-ricerca-nicola-navone!./.cache/json/en-gruppo-di-ricerca-nicola-navone.json
// module id = 574
// module chunks = 231608221292675